//-- Copyright (c) 2021 TMT Insights Group, LLC
import { useEffect } from 'react';
import PendingAssetsTitleBar from './PendingAssetsBar/PendingAssetsTitleBar';
import { setCurrentTable } from '../../redux/slices/dataTableSlice';
import TableContainer from '@/components/_common/Table/TableContainer';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import DataTableFilters from '../_common/Filters/DataTableFilters';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

const PendingAssets = () => {
  const dispatch = useAppDispatch();
  const currentTableKey = useAppSelector(selectCurrentTableKey);

  useEffect(() => {
    dispatch(setCurrentTable('pendingAssets'));
  }, []);

  return (
    <>
      {currentTableKey === 'pendingAssets' && (
        <>
          <PendingAssetsTitleBar />
          <DataTableFilters />
          {/* <PendingAssetsFilters /> */}
          <TableContainer />
        </>
      )}
    </>
  );
};

export default PendingAssets;
